import {colors} from "@c10h/colors";
import {useTranslation} from "@i18n/client";
import React from "react";
import {useCarbonForCampusConstants} from "src/constants/CarbonForCampus";
import useMediaQuery from "src/useMediaQuery";

import {Btn, ImgWithBg} from "../V5Comp";

const Hero: React.FC = () => {
  const i18n = useTranslation();
  const isXs = useMediaQuery("xs");
  const {ctaProps} = useCarbonForCampusConstants();

  const backgroundPosition = isXs ? "50% 20%" : "30% 70%";

  const bgImg = `/_clinic_photos/a-clinic${isXs ? "-mobile" : ""}`;
  return (
    <ImgWithBg
      bgImage={bgImg}
      className="minh140 pt58 pt24-xs pb100 pb120-xs ph8"
      style={{backgroundPosition}}
    >
      <div className="maxw80 ma">
        <div className="maxw32 maxw26-md">
          <h1 className="mb2 font-csb fs48 fs40-md fs28-xs">
            {i18n.t("Bring high-quality care to your students")}
          </h1>
          <p className="mb6 font-cm fs20 fs16-xs ls-3">
            {i18n.t(
              "Carbon for Campus partners with colleges to offer comprehensive care, flexible options, and lower costs.",
            )}
          </p>
          <div>
            <Btn
              href="#about"
              aria-label={i18n.t("Click to scroll to the next section.")}
              className="mr2 mb2 fs12-f-xs focus-bsDarkBlue3"
            >
              {i18n.t("Learn More")}
            </Btn>
            <Btn
              {...ctaProps}
              bg={colors.gray200}
              hoverBg={colors.gray200}
              color={colors.gray800}
              className="fs12-f-xs focus-bsDarkBlue3"
            />
          </div>
        </div>
      </div>
    </ImgWithBg>
  );
};

export default Hero;
